import {
  fetchBackmarketRateDistribution,
  fetchBackmarketReviewsBreadcrumb,
  fetchBackmarketReviewsList,
  fetchLandingRateDistribution,
  fetchLandingReviewsBreadcrumb,
  fetchLandingReviewsList,
  fetchMerchantRateDistribution,
  fetchMerchantReviewsBreadcrumb,
  fetchMerchantReviewsList,
  fetchProductRateDistribution,
  fetchReviewsBreadcrumbByProduct,
  fetchReviewsListByProductLegacy,
} from '@http/endpoints'
import { ROUTES } from '@router'

const getConfig = ({ landingId, productId, sellerId, name, limit }) => {
  let queryParams

  switch (name) {
    case ROUTES.REVIEWS.PAGES.MERCHANT:
      queryParams = {
        id: sellerId,
      }

      return {
        rateModule: 'merchant',
        endpoints: {
          list: fetchMerchantReviewsList,
          summary: fetchMerchantRateDistribution,
          breadcrumb: fetchMerchantReviewsBreadcrumb,
        },
        queryParams,
      }

    case ROUTES.REVIEWS.PAGES.LANDING: {
      queryParams = {
        pk: landingId,
      }

      if (limit) {
        queryParams.limit = limit
      }

      return {
        rateModule: 'landing',
        endpoints: {
          list: fetchLandingReviewsList,
          summary: fetchLandingRateDistribution,
          breadcrumb: fetchLandingReviewsBreadcrumb,
        },
        queryParams,
      }
    }

    case ROUTES.REVIEWS.PAGES.PRODUCT:
      return {
        rateModule: 'product',
        endpoints: {
          list: fetchReviewsListByProductLegacy,
          summary: fetchProductRateDistribution,
          breadcrumb: fetchReviewsBreadcrumbByProduct,
        },
        pathParams: { productId },
        // [COM-362] TODO to remove withReviewTranslation when it is done on BE side
        queryParams: { withReviewTranslation: true },
      }

    default:
      return {
        rateModule: 'backmarket',
        endpoints: {
          list: fetchBackmarketReviewsList,
          summary: fetchBackmarketRateDistribution,
          breadcrumb: fetchBackmarketReviewsBreadcrumb,
        },
      }
  }
}

export default getConfig
